
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Task, TaskType } from "@/types/task";
import { useTaskForm } from "@/hooks/useTaskForm";
import { TaskFormBasicInfo } from "./TaskDialog/TaskFormBasicInfo";
import { TaskFormDetails } from "./TaskDialog/TaskFormDetails";
import { TaskFormAssignments } from "./TaskDialog/TaskFormAssignments";
import { TaskFormScheduling } from "./TaskDialog/TaskFormScheduling";
import { TaskDialogActions } from "./TaskDialog/TaskDialogActions";

interface TaskDialogProps {
  task?: Task | null;
  onSuccess?: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  taskTypes?: TaskType[];
}

const defaultTaskTypes: TaskType[] = [
    { id: 'client', name: 'مهمة عميل', description: 'مهام متعلقة بالعملاء', color: '#3b82f6', created_at: new Date().toISOString() },
    { id: 'supplier', name: 'مهمة مورد', description: 'مهام متعلقة بالموردين', color: '#10b981', created_at: new Date().toISOString() },
    { id: 'administrative', name: 'مهمة إدارية', description: 'مهام إدارية داخلية', color: '#f59e0b', created_at: new Date().toISOString() },
    { id: 'operational', name: 'مهمة تشغيلية', description: 'مهام تشغيلية يومية', color: '#8b5cf6', created_at: new Date().toISOString() },
    { id: 'general', name: 'مهمة عامة', description: 'مهام عامة متنوعة', color: '#6b7280', created_at: new Date().toISOString() }
];

export const TaskDialog = ({ task, onSuccess, open, onOpenChange, taskTypes: externalTaskTypes }: TaskDialogProps) => {
  const taskTypes = externalTaskTypes || defaultTaskTypes;
  
  const {
    formData,
    setFormData,
    customType,
    setCustomType,
    handleSubmit,
    handleDelete,
    isSubmitting,
    categories,
    employees,
    clients,
    companies,
    suppliers
  } = useTaskForm(task, onSuccess, onOpenChange, taskTypes, open);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{task ? "تعديل المهمة" : "إضافة مهمة جديدة"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <TaskFormBasicInfo formData={formData} setFormData={setFormData} />
            <TaskFormDetails
              formData={formData}
              setFormData={setFormData}
              customType={customType}
              setCustomType={setCustomType}
              taskTypes={taskTypes}
              categories={categories}
            />
            <TaskFormAssignments
              formData={formData}
              setFormData={setFormData}
              employees={employees}
              clients={clients}
              companies={companies}
              suppliers={suppliers}
            />
            <TaskFormScheduling formData={formData} setFormData={setFormData} />
          </div>
          
          <TaskDialogActions
            task={task}
            onDelete={handleDelete}
            onCancel={() => onOpenChange(false)}
            isSubmitting={isSubmitting}
          />
        </form>
      </DialogContent>
    </Dialog>
  );
};
